module.exports = __webpack_public_path__ + "media/trumpet-392Hz.7f76de3b.wav";